export default __webpack_public_path__ + "static/media/Error.991f25f6.svg";